import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_CLIENT_ITEM_RESET = 'DELETE_CLIENT_ITEM_RESET';
export const DELETE_CLIENT_ITEM_LOADING = 'DELETE_CLIENT_ITEM_LOADING';
export const DELETE_CLIENT_ITEM_SUCCESS = 'DELETE_CLIENT_ITEM_SUCCESS';
export const DELETE_CLIENT_ITEM_REJECT = 'DELETE_CLIENT_ITEM_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteClientItemReset = () => ({ type: DELETE_CLIENT_ITEM_RESET });
export const deleteClientItemLoading = () => ({ type: DELETE_CLIENT_ITEM_LOADING });
export const deleteClientItemSuccess = (payload) => ({ type: DELETE_CLIENT_ITEM_SUCCESS, payload });
export const deleteClientItemReject = (payload) => ({ type: DELETE_CLIENT_ITEM_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteClientItemRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/api/Items/DeleteClientItem/${data.id}`, options);
};